import { TS_ItemType } from './TS_ItemType';
import { TS_Addon }    from './TS_Addon';

export class TS_AddonFlexPep extends TS_Addon {
    type = TS_ItemType.FLEX_PEP;

    descriptionList: string[];
}